module.exports = __webpack_public_path__ + "static/hero-6563660a402d445e789acdfa9965afdb.mp4";